/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.222.1-v202611040406-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqMaterializedTablesApiClass {
 
   constructor() {}

  /**
   * @summary Delete rows from a materialized table
   * @param {string} tableId - The id of the table to delete rows from
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public deleteRows(
    body: models.DeleteRowsInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/materialized-tables/${encodeURIComponent(String(tableId))}/deleteRows`
      .replace('{tableId}', encodeURIComponent(String(tableId)));
    const urlTemplate = `${baseUrl}/materialized-tables/{tableId}/deleteRows`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DeleteRowsOutputV1>;
  }

  /**
   * @summary Publish events to a materialized table
   * @param {string} tableId - ID of the table to publish events to
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public publishEvents(
    body: models.PublishEventsInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/materialized-tables/${encodeURIComponent(String(tableId))}/publishEvents`
      .replace('{tableId}', encodeURIComponent(String(tableId)));
    const urlTemplate = `${baseUrl}/materialized-tables/{tableId}/publishEvents`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.PublishEventsOutputV1>;
  }

  /**
   * @summary Recompute columns in materialized table
   * @param {string} tableId - ID of the table being recomputed
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public recomputeTable(
    body: models.RecomputeTableInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/materialized-tables/${encodeURIComponent(String(tableId))}/recomputeTable`
      .replace('{tableId}', encodeURIComponent(String(tableId)));
    const urlTemplate = `${baseUrl}/materialized-tables/{tableId}/recomputeTable`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.RecomputeTableOutputV1>;
  }

}


export const sqMaterializedTablesApi = new sqMaterializedTablesApiClass();

export type sqMaterializedTablesApiEndpoints = {
  'deleteRows': {
    method: 'post';
    path: '/materialized-tables/${encodeURIComponent(String(tableId))}/deleteRows';
    response: models.DeleteRowsOutputV1;
  };
  'publishEvents': {
    method: 'post';
    path: '/materialized-tables/${encodeURIComponent(String(tableId))}/publishEvents';
    response: models.PublishEventsOutputV1;
  };
  'recomputeTable': {
    method: 'post';
    path: '/materialized-tables/${encodeURIComponent(String(tableId))}/recomputeTable';
    response: models.RecomputeTableOutputV1;
  };
};

type ApiDeleteRowsResponse = models.DeleteRowsOutputV1;
type ApideleteRowsMutationParams = Parameters<typeof sqMaterializedTablesApi.deleteRows> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMaterializedTablesApi.deleteRows>;

export function useApiDeleteRowsMutation(
  options?: Omit<UseMutationOptions<ApiDeleteRowsResponse, AxiosError<SeeqErrorData>,
    ApideleteRowsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiDeleteRowsResponse, AxiosError<SeeqErrorData>,
  ApideleteRowsMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApideleteRowsMutationParams) =>
      sqMaterializedTablesApi.deleteRows(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPublishEventsResponse = models.PublishEventsOutputV1;
type ApipublishEventsMutationParams = Parameters<typeof sqMaterializedTablesApi.publishEvents> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMaterializedTablesApi.publishEvents>;

export function useApiPublishEventsMutation(
  options?: Omit<UseMutationOptions<ApiPublishEventsResponse, AxiosError<SeeqErrorData>,
    ApipublishEventsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPublishEventsResponse, AxiosError<SeeqErrorData>,
  ApipublishEventsMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApipublishEventsMutationParams) =>
      sqMaterializedTablesApi.publishEvents(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRecomputeTableResponse = models.RecomputeTableOutputV1;
type ApirecomputeTableMutationParams = Parameters<typeof sqMaterializedTablesApi.recomputeTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMaterializedTablesApi.recomputeTable>;

export function useApiRecomputeTableMutation(
  options?: Omit<UseMutationOptions<ApiRecomputeTableResponse, AxiosError<SeeqErrorData>,
    ApirecomputeTableMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiRecomputeTableResponse, AxiosError<SeeqErrorData>,
  ApirecomputeTableMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApirecomputeTableMutationParams) =>
      sqMaterializedTablesApi.recomputeTable(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
